<script>
import { mapState } from "vuex";
import compBaptisDetail from "@/components/umatDetail/baptis";
import compKomuniDetail from "@/components/umatDetail/komuni";
import { SweetModal } from "sweet-modal-vue";
import config from "@/data/config";
import APIService from "@/services/api.service";
import axios from "axios";

export default {
	name: "compKrismaDetail",
	components: {
		compBaptisDetail,
		compKomuniDetail,
		SweetModal,
	},
	data() {
		return {
			loading: false,
			frameLoading: false,
			baseURL: config.baseURL,
			windowHeight: window.innerHeight - 250,
			fileURL: "",
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
         auth: (state) => state.auth.user,
			umatItem: (state) => state.umat.item,
			umatKrismaItem: (state) => state.umatKrisma.item,
			umatPerkawinanItem: (state) => state.umatPerkawinan.item,
			umatKematianItem: (state) => state.umatKematian.item,
			keluargaKatolikItem: (state) => state.keluargaKatolik.item,
		}),
		getStatus() {
			return (value) =>
				value > 0
					? '<i class="fa fa-check text-success"></i>'
					: '<i class="fa fa-times text-dark"></i>';
		},
		arrayToString() {
			return (value) => (value ? value.join(",") : "");
		},
		getJK() {
			return (jk) => (jk === "L" ? "Laki-laki" : "Perempuan");
		},
		getAva() {
			return (value) => {
				const L = ["l-1.png", "l-2.png", "l-3.png", "l-4.png"];
				const P = ["p-1.png", "p-2.png", "p-3.png", "p-4.png"];

				let images = require.context(
					"@/assets/images/avtar/",
					false,
					/\.png$/
				);

				if (value === "L") {
					return images("./" + L[Math.floor(Math.random() * L.length)]);
				} else {
					return images("./" + P[Math.floor(Math.random() * P.length)]);
				}
			};
		},
	},
	watch: {
		loading: function (val) {
			if (val) {
				this.$swal({ text: "Loading", allowOutsideClick: false });
				this.$swal.showLoading();
			} else {
				this.$swal.close();
			}
		},
	},
	methods: {
		resetPDF() {
			this.loading = true;
			this.frameLoading = true;
			this.fileURL = this.baseURL + "assets/_blank.pdf";
		},
		onSuccess(response) {
         const timestamp = this.$moment().toDate().getTime()
			this.loading = false;
			this.fileURL = this.baseURL + "pdf/" + response.data.filename + ".pdf?v=" + timestamp;
			this.$refs.modalfile.open();
		},
		showPDFBaptis() {
			this.resetPDF();

			axios
				.post(APIService.getPDFBaptis(), this.umatItem, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.onSuccess(response);
					},
					() => {
						this.loading = false;
					}
				);
		},
		showPDFKomuni() {
			this.resetPDF();

			axios
				.post(APIService.getPDFKomuni(), this.umatItem, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.onSuccess(response);
					},
					() => {
						this.loading = false;
					}
				);
		},
		showPDFKrisma() {
			this.resetPDF();

			axios
				.post(APIService.getPDFKrisma(), this.umatItem, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.onSuccess(response);
					},
					() => {
						this.loading = false;
					}
				);
		},
		showPDFPerkawinan() {
			this.resetPDF();

			axios
				.post(APIService.getPDFPerkawinan(), this.umatItem, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.onSuccess(response);
					},
					() => {
						this.loading = false;
					}
				);
		},
		showPDFKK() {
			this.resetPDF();

			axios
				.post(APIService.getPDFKK(), this.umatItem, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.onSuccess(response);
					},
					() => {
						this.loading = false;
					}
				);
		},
		load() {
			this.frameLoading = false;
		},
	},
};
</script>

<template>
	<div>
		<div class="row">
			<div class="col-xl-9">
				<div class="card text-left">
					<div class="blog-box blog-list row">
						<div class="col-sm-2">
							<img
								class="img-fluid sm-100-w"
								:src="getAva(umatItem.jk)"
								alt=""
							/>
						</div>
						<div class="col-sm-10">
							<div class="blog-details">
								<div class="blog-date digits">
									<span>{{ umatItem.nama }} </span>
								</div>
								<h6>{{ getJK(umatItem.jk) }}</h6>
								<div class="blog-bottom-content">
									<ul class="blog-social">
										<li>
											{{ umatItem.tempat_lahir }},
											{{
												$moment(umatItem.tgl_lahir).format(
													"DD MMMM YYYY"
												)
											}}
										</li>
										<li>{{ $moment().diff(umatItem.tgl_lahir, 'years') }} Tahun</li>
										<li>{{ umatItem.agama }}</li>
									</ul>
									<hr />
									<p class="mt-0">
										Suku {{ umatItem.suku }}, Pendidikan
										{{ umatItem.pendidikan }}, Pekerjaan
										{{ umatItem.pekerjaan }}, Gol. Darah
										{{ umatItem.gol_darah }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="default-according style-1 faq-accordion">
					<div class="row">
						<div class="col-md-12">
							<b-card no-body>
								<b-card-header header-tag="div" role="tab">
									<h5 class="mb-0">
										<button
											v-b-toggle.collapseBaptis
											class="btn btn-link collapsed"
										>
											<span
												v-html="getStatus(umatItem.is_baptis)"
											></span>
											Baptis
										</button>
									</h5>
								</b-card-header>
								<b-collapse id="collapseBaptis" role="tabpanel">
									<b-card-body><compBaptisDetail /></b-card-body>
								</b-collapse>
							</b-card>
						</div>

						<div class="col-md-12">
							<hr />
							<b-card no-body>
								<b-card-header header-tag="div" role="tab">
									<h5 class="mb-0">
										<button
											v-b-toggle.collapseKomuni
											class="btn btn-link collapsed"
										>
											<span
												v-html="getStatus(umatItem.is_komuni)"
											></span>
											Komuni I
										</button>
									</h5>
								</b-card-header>
								<b-collapse id="collapseKomuni" role="tabpanel">
									<b-card-body><compKomuniDetail /></b-card-body>
								</b-collapse>
							</b-card>
						</div>
						<div class="col-md-12">
							<hr />
							<b-card no-body>
								<b-card-header header-tag="div" role="tab">
									<h5 class="mb-0">
										<button
											v-b-toggle.collapseKrisma
											class="btn btn-link collapsed"
										>
											<span
												v-html="getStatus(umatItem.is_krisma)"
											></span>
											Krisma
										</button>
									</h5>
								</b-card-header>
								<b-collapse id="collapseKrisma" role="tabpanel">
									<b-card-body
										><table
											class="
												table table-striped table-hover
												text-left
											"
										>
											<tbody>
												<tr>
													<td>No Buku LC</td>
													<td>:</td>
													<td>{{ umatKrismaItem.no_buku_lc }}</td>
												</tr>
												<tr>
													<td>No LC</td>
													<td>:</td>
													<td>{{ umatKrismaItem.no_lc }}</td>
												</tr>
												<tr>
													<td>Tanggal Krisma</td>
													<td>:</td>
													<td>
														{{ umatKrismaItem.tgl_krisma_human }}
													</td>
												</tr>
												<tr>
													<td>Pemberi Krisma</td>
													<td>:</td>
													<td>
														{{ umatKrismaItem.pemberi_krisma }}
													</td>
												</tr>
												<tr>
													<td>Wali I</td>
													<td>:</td>
													<td>
														{{ umatKrismaItem.wali1 }}
													</td>
												</tr>
												<tr>
													<td>Wali II</td>
													<td>:</td>
													<td>
														{{ umatKrismaItem.wali2 }}
													</td>
												</tr>
												<tr>
													<td>Keuskupan LC</td>
													<td>:</td>
													<td>
														{{ umatKrismaItem.keuskupan_lc }}
													</td>
												</tr>
												<tr>
													<td>Paroki LC</td>
													<td>:</td>
													<td>{{ umatKrismaItem.paroki_lc }}</td>
												</tr>
											</tbody>
										</table></b-card-body
									>
								</b-collapse>
							</b-card>
						</div>
						<div class="col-md-12">
							<hr />
							<b-card no-body>
								<b-card-header header-tag="div" role="tab">
									<h5 class="mb-0">
										<button
											v-b-toggle.collapsePerkawinan
											class="btn btn-link collapsed"
										>
											<span
												v-html="getStatus(umatItem.is_perkawinan)"
											></span>
											Perkawinan
										</button>
									</h5>
								</b-card-header>
								<b-collapse id="collapsePerkawinan" role="tabpanel">
									<b-card-body
										><table
											class="
												table table-striped table-hover
												text-left
											"
										>
											<tbody>
												<tr>
													<td>Nama Pasangan</td>
													<td>:</td>
													<td>
														{{ umatPerkawinanItem.nama_pasangan }}
													</td>
												</tr>

												<tr>
													<td>No. Buku LM</td>
													<td>:</td>
													<td>
														{{ umatPerkawinanItem.no_buku_lm }}
													</td>
												</tr>
												<tr>
													<td>No. LM</td>
													<td>:</td>
													<td>{{ umatPerkawinanItem.no_lm }}</td>
												</tr>
												<tr>
													<td>Tanggal Perkawinan</td>
													<td>:</td>
													<td>
														{{
															umatPerkawinanItem.tgl_perkawinan_human
														}}
													</td>
												</tr>
												<tr>
													<td>Imam Peneguh</td>
													<td>:</td>
													<td>
														{{ umatPerkawinanItem.imam_peneguh }}
													</td>
												</tr>
												<tr>
													<td>Keuskupan LC</td>
													<td>:</td>
													<td>
														{{ umatPerkawinanItem.keuskupan_lm }}
													</td>
												</tr>
												<tr>
													<td>Paroki LC</td>
													<td>:</td>
													<td>
														{{ umatPerkawinanItem.paroki_lm }}
													</td>
												</tr>
												<tr>
													<td>Nama Saksi I</td>
													<td>:</td>
													<td>{{ umatPerkawinanItem.wali }}</td>
												</tr>
												<tr>
													<td>Nama Saksi II</td>
													<td>:</td>
													<td>{{ umatPerkawinanItem.wali2 }}</td>
												</tr>
											</tbody>
										</table></b-card-body
									>
								</b-collapse>
							</b-card>
						</div>
                  <div class="col-md-12">
							<hr />
							<b-card no-body>
								<b-card-header header-tag="div" role="tab">
									<h5 class="mb-0">
										<button
											v-b-toggle.collapseKematian
											class="btn btn-link collapsed"
										>
											<span
												v-html="getStatus(umatItem.is_kematian)"
											></span>
											Kematian
										</button>
									</h5>
								</b-card-header>
								<b-collapse id="collapseKematian" role="tabpanel">
									<b-card-body
										><table
											class="
												table table-striped table-hover
												text-left
											"
										>
											<tbody>
												<tr>
													<td>Tanggal Meninggal </td>
													<td>:</td>
													<td>
														{{ umatKematianItem.tgl_meninggal_human }}
													</td>
												</tr>
												<tr>
													<td>Tempat Meninggal</td>
													<td>:</td>
													<td>
														{{ umatKematianItem.tempat_meninggal }}
													</td>
												</tr>
											</tbody>
										</table></b-card-body
									>
								</b-collapse>
							</b-card>
						</div>
					</div>
					<div></div>
				</div>
			</div>
			<div
				class="col-xl-3 default-according style-1 faq-accordion text-left"
            
			>
				<b-card no-body v-show="this.auth.group_id != '3'">
					<b-card-header header-tag="div" role="tab">
						<h5 class="mb-0">
							<button v-b-toggle.pdf class="btn btn-link collapsed pl-0">
								Dokumen PDF
							</button>
						</h5>
					</b-card-header>
					<b-collapse id="pdf" role="tabpanel" visible>
						<b-card-body class="p-0">
							<div class="categories">
								<ul>
									<li>
										Surat Baptis
										<div class="pull-right">
											<b-button
												variant="primary"
												size="xs"
												@click="showPDFBaptis()"
												><small>PDF</small></b-button
											>
										</div>
									</li>
									<li>
										Komuni I
										<div class="pull-right">
											<b-button
												variant="primary"
												size="xs"
												@click="showPDFKomuni()"
												><small>PDF</small></b-button
											>
										</div>
									</li>
									<li>
										Krisma
										<div class="pull-right">
											<b-button
												variant="primary"
												size="xs"
												@click="showPDFKrisma()"
												><small>PDF</small></b-button
											>
										</div>
									</li>
									<li>
										Perkawinan
										<div class="pull-right">
											<b-button
												variant="primary"
												size="xs"
												@click="showPDFPerkawinan()"
												><small>PDF</small></b-button
											>
										</div>
									</li>
									<li>
										Kartu Keluarga katolik
										<div class="pull-right">
											<b-button
												variant="primary"
												size="xs"
												@click="showPDFKK()"
												><small>PDF</small></b-button
											>
										</div>
									</li>
								</ul>
							</div>
						</b-card-body>
					</b-collapse>
				</b-card>
				<b-card no-body>
					<b-card-header header-tag="div" role="tab">
						<h5 class="mb-0">
							<button
								v-b-toggle.checklist
								class="btn btn-link collapsed pl-0"
							>
								Checklist
							</button>
						</h5>
					</b-card-header>
					<b-collapse id="checklist" role="tabpanel" visible>
						<b-card-body class="p-0">
							<div class="categories">
								<ul>
									<li>
										Baptis
										<span
											class="pull-right"
											v-html="getStatus(umatItem.is_baptis)"
										></span>
									</li>
									<li>
										Komuni I
										<span
											class="pull-right"
											v-html="getStatus(umatItem.is_komuni)"
										></span>
									</li>
									<li>
										Krisma
										<span
											class="pull-right"
											v-html="getStatus(umatItem.is_krisma)"
										></span>
									</li>
									<li>
										Perkawinan
										<span
											class="pull-right"
											v-html="getStatus(umatItem.is_perkawinan)"
										></span>
									</li>
									<li>
										Kematian
										<span
											class="pull-right"
											v-html="getStatus(umatItem.is_kematian)"
										></span>
									</li>
								</ul>
							</div>
						</b-card-body>
					</b-collapse>
				</b-card>
			</div>
		</div>

		<sweet-modal
			modal-theme="light"
			overlay-theme="dark"
			width="80%"
			ref="modalfile"
		>
			<div class="loader-box" v-show="frameLoading">
				<div class="loader-2"></div>
			</div>
			<iframe
				v-show="!frameLoading"
				width="100%"
				:height="windowHeight"
				:src="fileURL"
				frameborder="0"
				allowfullscreen
				@load="load()"
			></iframe>
		</sweet-modal>
	</div>
</template>

